import { Feature } from "ol";
import EsriJSON from "ol/format/EsriJSON";
import { Point, Polygon } from "ol/geom";
import { Circle, Fill, Stroke, Style } from "ol/style";
import { ClientLayer } from "../../../lib/layers";
export class SketchLayer extends ClientLayer {
    constructor() {
        super();
        this.feature_reader = new EsriJSON();
        this.features = [];
        this._isLayerActive = false;
        this.raw.setStyle([
            new Style({
                fill: new Fill({
                    color: 'rgba(255,255,255,0.5)'
                }),
                stroke: new Stroke({
                    color: '#ffcc33',
                    width: 2
                })
            }),
            new Style({
                image: new Circle({
                    radius: 2,
                    fill: new Fill({
                        color: 'orange'
                    }),
                }),
                geometry: function (feature) {
                    try {
                        let coords = feature.get('first_point');
                        return new Point(coords);
                    }
                    catch (_a) {
                        return new Point([0, 0]);
                    }
                }
            })
        ]);
    }
    get buildings() {
        return this.source.getFeatures();
    }
    get isLayerActive() {
        return this._isLayerActive;
    }
    set isLayerActive(value) {
        this._isLayerActive = value;
    }
    add_from_json(json_features) {
        this.features = this.feature_reader.readFeatures(json_features, { featureProjection: this.projection });
        this.source.addFeatures(this.features);
        this.isLayerActive = true;
    }
    remove() {
        this.features.forEach((feature) => {
            if (this.source.hasFeature(feature)) {
                this.source.removeFeature(feature);
            }
        });
        this.isLayerActive = false;
    }
    add_at_centroid(rings, centroid, attributes) {
        for (let boundary of rings) {
            for (let point of boundary) {
                point[0] += centroid[0];
                point[1] += centroid[1];
            }
        }
        const feature = new Feature(new Polygon(rings));
        for (let [key, val] of Object.entries(attributes)) {
            feature.set(key, val);
        }
        this.features.push(feature);
        this.source.addFeature(feature);
        this.isLayerActive = true;
    }
    buildings_to_string(buildings) {
        return this.feature_reader.writeFeatures(buildings);
    }
    building_to_json(bld_id) {
        const chosen_building_parts = this.buildings.filter(b => b.get('bld_id') === bld_id);
        return this.buildings_to_string(chosen_building_parts);
    }
    parcel_buildings_to_json(parcel_id) {
        const buildings_on_parcel = this.buildings.filter(b => b.get('parcel_id') === parcel_id);
        return this.buildings_to_string(buildings_on_parcel);
    }
    all_buildings_to_json() {
        return this.buildings_to_string(this.buildings);
    }
}
